import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { ProductCard } from "@/components/site/ProductCard";
import { PhotoSlot } from "@/components/site/PhotoSlot";
import { staggerContainer, IMAGES } from "@/lib/motion";
import { TEA } from "@/data/products";

export const Tea = () => (
  <section
    id="tea"
    data-testid="tea-section"
    className="bg-[#F5F2E9] py-24 lg:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-20 items-end mb-20 lg:mb-28">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="mb-5 text-xs md:text-sm uppercase tracking-[0.25em] text-[#7A4E24]">
              &#8212; Assam Tea
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl leading-[0.9] tracking-tight text-[#3D2817]">
              The Breakfast Tea
              <span className="block italic text-[#7A4E24]">of the World.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-[#6B4423]">
              {TEA.intro}
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal>
            {IMAGES.teaPlantation ? (
              <div className="overflow-hidden arch-frame border border-[#3D2817]">
                <img
                  src={IMAGES.teaPlantation}
                  alt="Assam tea plantation"
                  loading="lazy"
                  className="h-[26rem] w-full object-cover"
                />
              </div>
            ) : (
              <PhotoSlot
                testId="tea-photo-slot"
                caption="Assam Tea Gardens"
                label="Photo slot"
                height="h-[26rem]"
                shape="arch"
              />
            )}
          </Reveal>
        </div>
      </div>

      <motion.div
        className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.05 }}
      >
        {TEA.variants.map((v, i) => (
          <ProductCard
            key={v.id}
            testId={`tea-${v.id}`}
            name={v.name}
            image={v.image}
            description={v.description}
            size="md"
            shape={i === 1 ? "arch" : "rect"}
          />
        ))}
      </motion.div>
    </div>
  </section>
);
